import { render, staticRenderFns } from "./UNotification.vue?vue&type=template&id=b00f2ac6"
import script from "./UNotification.vue?vue&type=script&lang=js"
export * from "./UNotification.vue?vue&type=script&lang=js"
import style0 from "./UNotification.vue?vue&type=style&index=0&id=b00f2ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports